import { api, LightningElement } from "lwc";
import classNames from "classnames";

import { ContentSummary } from "tds/contentSummary";

export type Size = "small" | "medium" | "large" | "xlarge";
export type Variant = "circle" | "rounded" | "square";

export default class extends LightningElement {
  @api backgroundColor: string | null = null;
  @api checked: boolean = false;
  @api size: Size = "medium";
  @api src: string | null = null;
  @api variant: Variant = "rounded";
  @api contentType: ContentSummary["type"] | null = null;
  @api text: string | null = null;

  private get imageSize() {
    switch (this.size) {
      case "small":
        return 50;
      case "medium":
        return 64;
      case "large":
        return 78;
      case "xlarge":
        return 100;
      default:
        return 64;
    }
  }

  private get imageContainerStyles() {
    return classNames(
      `--image-size: ${this.imageSize}px;`,
      `--image-padding: ${this.imagePadding};`,
      `width: 100%;`,
      {
        [`--background-color: ${this.backgroundColor};`]: this.backgroundColor,
      }
    );
  }

  private get iconClassName() {
    return `icon icon--${this.size}`;
  }

  private get imagePadding() {
    switch (this.contentType) {
      case "trail":
        return "var(--tds-spacing-2)";
      default:
        return "0";
    }
  }
}
